import { forwardRef } from 'react';

import type {
  DateRangePickerProps as MuiDateRangePickerProps,
  PickerValidDate,
} from '@mui/x-date-pickers-pro';
import { DateRangePicker as MuiDateRangePicker } from '@mui/x-date-pickers-pro';

import { DateRangePickerWrapper } from '../date-range-picker-wrapper/date-range-picker-wrapper';

export type DateRangePickerProps = MuiDateRangePickerProps<
  PickerValidDate,
  false
>;

export const DateRangePicker = forwardRef<HTMLDivElement, DateRangePickerProps>(
  (props: DateRangePickerProps, ref) => (
    <DateRangePickerWrapper ref={ref}>
      <MuiDateRangePicker {...props} />
    </DateRangePickerWrapper>
  ),
);
